'use strict';
/* Unified Modal creation and handling functionality */
var modal = require('org/util/modal');
var utils = require('../util/utils');

module.exports = function () {
    $('document').ready(function () {
        var url = $('#geoPopupURL').data('url');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {},
            success: function (response) {
                if (response.displayModal) {
                    utils.waitForOneTrustConsent().then(() => {
                        // Safe to trigger other UI events or modals here
                        setTimeout(() => {
                            modal.create(response.renderedTemplate);
                        }, 2000);
                    });
                }
            }
        });
    });

    $('body').on('click', '.redirect-control', function () {
        const reqURL = $('#reqURL').val();
        const currentCountryCode = $('#currentCountryCode').val();
        let redirectURL = null;
        $.ajax({
            url: reqURL,
            type: 'post',
            dataType: 'json',
            data: { selectedCountryCode: currentCountryCode },
            success: (res) => {
                if (res.redirectURL && res.redirectURL !== '') {
                    redirectURL = res.redirectURL;
                    window.location.replace(redirectURL);
                } else {
                    $('#geo-redirect-modal').modal('hide');
                    window.location.reload();
                }
            }
        });
    });
    $('body').on('click', '#geoPopupCloseBtn', '.geo-redirect-dismiss', function () {
        $('#geo-redirect-modal').modal('hide');
    }).on('change', '#geoCountrySelector', function () {
        let reqURL = $('#reqURL').val();
        let selectedCountryCode = $(this).val();
        let redirectURL;
        $.ajax({
            url: reqURL,
            type: 'post',
            dataType: 'json',
            data: { selectedCountryCode: selectedCountryCode },
            success: (res) => {
                if (res.redirectURL !== '') {
                    redirectURL = res.redirectURL;
                    window.location.replace(redirectURL);
                } else {
                    $('#geo-redirect-modal').modal('hide');
                    window.location.reload();
                }
            }
        });
    });
};
